// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import usePartnerAuth from 'hooks/usePartnerAuth';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { isAdmin } = usePartnerAuth();

  // `adminOnly` entries disappear for members. This is presentation only — the
  // routes and the APIs behind them refuse a member on their own.
  const visible = (item) => !item.adminOnly || isAdmin;

  const navGroups = menuItem.items.filter(visible).map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={{ ...item, children: (item.children || []).filter(visible) }} />;
      default:
        return (
          <Typography key={item.id} variant="h6" sx={{ color: 'error.main', textAlign: 'center' }}>
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
